/**
 * Checks if a string value is a valid numeric value
 * @param value The value to check
 * @returns True if the value represents a valid number
 */
export function isNumeric(value: any): boolean {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  return /^-?\d*\.?\d+$/.test(String(value));
}